import {ChainInvoice} from '@model/ChainInvoice';

export class ExportDate {
  hoId: string;
  chnInvList: ChainInvoice[];
}
